$(function () {
  (window.controllers = window.controllers || {}),
    (window.controllers.staticHeader = function (o, s) {
      var t, e, i, n, a, c;
      console.log("[staticHeader]", "init"),
        _.delay(function () {
          $(".before-load").removeClass("before-load");
        }, 750),
        (t = !1),
        (e = o.find("[data-sticky-header]")),
        (i = null),
        (n = function (s) {
          clearTimeout(i),
            o.removeClass("js-is-after-sticky"),
            s
              ? o.removeClass("js-is-sticky")
              : t &&
                e
                  .stop(!0, !0)
                  .animate({ top: -110 }, 500, "easeInOutExpo")
                  .promise()
                  .then(function () {
                    $(this).css({ display: "", opacity: "", top: "" }),
                      o.removeClass("js-is-sticky");
                  }),
            (t = !1);
        }),
        (a = [0, 0, 0, 0, 0, 0, 0, 0]),
        (c = 0),
        $(window).on(
          "scroll",
          _.throttle(function () {
            var l = $(window).scrollTop(),
              r = o.offset().top;
            s.offset && (r -= Number(s.offset));
            var p =
              a.reduce(function (o, s) {
                return o + s;
              }) >= 6;
            r < l
              ? (o.addClass("js-is-past-visible"),
                p
                  ? (o.addClass("js-is-sticky"),
                    t ||
                      (clearTimeout(i),
                      (i = _.delay(function () {
                        o.addClass("js-is-after-sticky");
                      }, 500)),
                      e
                        .css({ top: -110, opacity: 0 })
                        .stop(!0, !0)
                        .animate({ opacity: 1, top: 0 }, 700, "easeInOutExpo")
                        .promise()
                        .then(function () {
                          $(this).css({ display: "", opacity: "", top: "" });
                        })),
                    (t = !0))
                  : n())
              : o.removeClass("js-is-past-visible"),
              t && l <= 0 && n(!0),
              a.pop(),
              a.unshift(c > l ? 1 : -1),
              (c = l);
          }, 1)
        );
    }),
    (window.controllers.popup = function (o, s) {
      console.log("[popup]", "Init");
      var t = o.data("trigger-selector"),
        e = $(t),
        i = o;
      console.log("[popup]", "Trigger selector: ", t, " Count: ", e.length);
      var n = function () {
          i.fadeIn(500, "easeInOutExpo"), console.log("[popup]", "show()");
        },
        a = function () {
          i.fadeOut(500, "easeInOutExpo"), console.log("[popup]", "hide()");
        };
      i.on("click", function (o) {
        0 == $(o.target).closest(".popup__content").length && a();
      }),
        $(document).on("keydown", function (o) {
          27 == o.keyCode && a();
        });
      var c = function () {
        i.is(":visible") && i.css("opacity") > 0.5 ? a() : n();
      };
      (e.on("click", c),
      o.find("[data-popup-close]").on("click", c),
      s.displayIn) &&
        (window.utils.cookies.get(s.cookieName || "popup-cookie") ||
          setTimeout(function () {
            n(), window.utils.cookies.set(s.cookieName, !0);
          }, s.displayIn));
    }),
    (window.controllers.ajaxChimp = function (o, s) {
      o.find("form").ajaxChimp({
        callback: function (s) {
          console.log("[ajaxChimp]", "Callback", s);
          var t = !0;
          "success" == s.result &&
            (console.log("[ajaxChimp]", "Success!"),
            o.addClass("js-submitted"),
            o.find("form").html("Good move..."),
            (t = !1));
          var e = s.msg.split(" - ")[1];
          $(".newsletter__privacy").html(e),
            t
              ? o.addClass("js-error")
              : (o.removeClass("js-error"),
                o.addClass("js-success"),
                $(".newsletter__privacy").hide());
        },
      });
    }),
    (window.controllers.productDescription = function (o, s) {
      var t = $("<div/>");
      (t = t.html(o.html())),
      $("[data-product-description-first-paragraph]")
        .html(t.find("p:first").text())
        .css("opacity", 0)
        .animate({ opacity: 1 }, 500),
        t.find("p:first").remove(),
        $("[data-product-description-the-rest]").html(t);console.log('test')
    });
    // (window.controllers.productDescription = function (o, s) {
    //     var t = $("<div/>");
    //     (t = t.html(o.html())),
    //       $("[data-product-description-first-paragraph]")
    //         .html(t.find("p:first").text())
    //         .css("opacity", 0)
    //         .animate({ opacity: 1 }, 500),
    //       t.find("p:first").remove(),
    //       $("[data-product-description-the-rest]")
    //       .html(t.find("p:first , ul:first"))
    //         .css("opacity", 0)
    //         .animate({ opacity: 1 }, 500),
    //       t.find("p:first , ul:first").remove(),
           
    //       $("[data-product-description-the-measurements]").html(t);
    //   });
});
